import { call, put, takeLatest } from 'redux-saga/effects';
import makeSagaRequest from 'app/shared/sagas/makeSagaRequest';

// Models
import { RulesActionTypes } from 'app/modules/rules/models';

// Actions
import {
  whitelistEntitiesForRule as whitelistEntitiesForRuleAction,
  whitelistEntitiesForRuleSuccess,
} from 'app/modules/rules/actions';
import { sendSuccessToast } from 'app/shared/toasts/actions';

// API
import { addWhitelistedEntitiesForRule } from 'app/shared/api/rules';

const rootAction = RulesActionTypes.WHITELIST_ENTITIES_FOR_RULE;
function* whitelistEntitiesForRule({
  payload,
}: ReturnType<typeof whitelistEntitiesForRuleAction>) {
  const entityMessage =
    payload.entity_external_ids.length > 1 ? 'entities' : 'entity';
  const config = {
    rootAction,
    request: call(addWhitelistedEntitiesForRule, payload),
    success: function* onSuccess() {
      yield put(whitelistEntitiesForRuleSuccess());
      yield put(sendSuccessToast(`Added ${entityMessage} to rule whitelist`));
    },
  };

  yield call(makeSagaRequest, config);
}

export default function* watchWhitelistEntitiesForRuleStatus() {
  yield takeLatest(rootAction, whitelistEntitiesForRule);
}
